import gql from 'graphql-tag';

import client from '../graphqlAPI';

const CLONE_EMAIL_CAMPAIGN_MUTATION = gql`
  mutation cloneEmailCampaign($sourceKey: String!, $newKey: String!, $newTitle: String!) {
    cloneEmailCampaign(sourceKey: $sourceKey, newKey: $newKey, newTitle: $newTitle) {
      isAuth
      success
      error
      campaign {
        key
        title
        kind
        isActive
        templateCount
        inactiveCount
        hasAnyTemplate
        createdAt
        languages {
          language
          status
        }
      }
      templates {
        _id
        templateId
        name
        language
        scope
        subject
        isActive
        variables
      }
    }
  }
`;

const cloneEmailCampaign = async ({ sourceKey, newKey, newTitle }) => {
  try {
    const result = await client
      .mutate({
        mutation: CLONE_EMAIL_CAMPAIGN_MUTATION,
        variables: { sourceKey, newKey, newTitle },
        fetchPolicy: 'no-cache',
      })
      .then(mutationResult => mutationResult)
      .catch((mutationError) => {
        console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: Apollo Client Mutation Error: ${mutationError}`);
        return null;
      });

    const { data: { cloneEmailCampaign: cloneEmailCampaignData } } = result;

    if (cloneEmailCampaignData) return cloneEmailCampaignData;

    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: GraphQL Mutation Error: cloneEmailCampaignData = null`);
    return null;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: cloneEmailCampaign Error: ${error}`);
    return null;
  }
};

export default cloneEmailCampaign;
